import createIcon from '../../createIcon';

/**
 * @component @name SettingsPhone
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTMgOUgxMVYxMUgxM1Y5Wk0xNyA5SDE1VjExSDE3VjlaTTIwIDE1LjVDMTguNzUgMTUuNSAxNy41NSAxNS4zIDE2LjQzIDE0LjkzQzE2LjA4IDE0LjgyIDE1LjY5IDE0LjkgMTUuNDEgMTUuMTdMMTMuMjEgMTcuMzdDMTAuMzggMTUuOTMgOC4wNiAxMy42MiA2LjYyIDEwLjc5TDguODIgOC41OEM5LjEgOC4zMSA5LjE4IDcuOTIgOS4wNyA3LjU3QzguNyA2LjQ1IDguNSA1LjI1IDguNSA0QzguNSAzLjQ1IDguMDUgMyA3LjUgM0g0QzMuNDUgMyAzIDMuNDUgMyA0QzMgMTMuMzkgMTAuNjEgMjEgMjAgMjFDMjAuNTUgMjEgMjEgMjAuNTUgMjEgMjBWMTYuNUMyMSAxNS45NSAyMC41NSAxNS41IDIwIDE1LjVaTTE5IDlWMTFIMjFWOUgxOVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SettingsPhone = createIcon('SettingsPhone', [
  [
    'path',
    {
      d: 'M13 9H11V11H13V9ZM17 9H15V11H17V9ZM20 15.5C18.75 15.5 17.55 15.3 16.43 14.93C16.08 14.82 15.69 14.9 15.41 15.17L13.21 17.37C10.38 15.93 8.06 13.62 6.62 10.79L8.82 8.58C9.1 8.31 9.18 7.92 9.07 7.57C8.7 6.45 8.5 5.25 8.5 4C8.5 3.45 8.05 3 7.5 3H4C3.45 3 3 3.45 3 4C3 13.39 10.61 21 20 21C20.55 21 21 20.55 21 20V16.5C21 15.95 20.55 15.5 20 15.5ZM19 9V11H21V9H19Z',
      key: 'vjt6p6',
    },
  ],
]);

export default SettingsPhone;
